module.exports = __webpack_public_path__ + "static/media/icon_import_success_result.7e9fd339.svg";